"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContext = void 0;
var storefront_client_1 = require("@rechargeapps/storefront-client");
var Cookies = __importStar(require("js-cookie"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var existing_customer_new_bundle_1 = require("../../misc/existing-customer-new-bundle");
var recharge_bundles_1 = require("../../misc/recharge-bundles");
var recharge_storefront_1 = require("../../misc/recharge-storefront");
var store_credit_1 = require("../../misc/store-credit");
var api_1 = require("../account-v3/api");
var loading_modal_1 = __importDefault(require("../account-v3/components/loading_modal"));
var update_subscription_1 = require("../account-v3/mutations/update-subscription");
var utils_1 = require("../account-v3/utils");
var is_variant_available_1 = __importDefault(require("../bundler/is-variant-available"));
var existing_customer_new_bundle_modal_1 = __importDefault(require("./components/existing-customer-new-bundle-modal"));
var free_shipping_progress_1 = __importDefault(require("./components/free-shipping-progress"));
var header_1 = __importDefault(require("./components/header"));
var nav_bar_1 = __importDefault(require("./nav-bar"));
var progress_bar_1 = __importDefault(require("./progress-bar"));
var review_1 = __importDefault(require("./steps/review"));
var select_products_1 = __importDefault(require("./steps/select-products"));
var useMemo = react_1.default.useMemo;
exports.AppContext = (0, react_1.createContext)({
    availableChoices: [],
    selectedChoices: [],
    filteredPromotionalAddOns: [],
    addChoice: function () { return undefined; },
    subChoice: function () { return undefined; },
    setFrequency: function () { return undefined; },
    isSubmittingBundle: false,
    minSelectionTotal: undefined,
    submitBundle: function () { return undefined; },
    setLeftSideImage: function () { return null; },
    totalNumChoices: 0,
    subTotalBundlePrice: 0,
    totalBundlePrice: 0,
    qualifiesForFreeShipping: false,
});
var App = function (props) {
    var _a;
    var existingBundle = props.existingBundle, products = props.products, location = props.location, shippingIntervalFrequencies = props.shippingIntervalFrequencies, shippingIntervalUnitType = props.shippingIntervalUnitType, subscriptionId = props.subscriptionId, settings = props.settings, subscriptionUrlLocation = props.subscriptionUrlLocation, promotionalCodeProducts = props.promotionalCodeProducts, promotionalCodeProductsMetafields = props.promotionalCodeProductsMetafields, mainRcBundleProduct = props.mainRcBundleProduct;
    // as of 07/29/21, we don't offer free shipping for Fundamentals Bundles
    // toggle this to true if things change
    var freeShippingAvailable = false;
    // the min number of products needed to create an essentials bundle & min needed to spend for free shipping
    // these are set from CMS and are passed in as string; so we need to convert to number
    var minSelectionTotal = Number(settings.app.minSelection);
    var minPriceForFreeShipping = Number(settings.app.minFreeShipping);
    // need a scroll container const to target for scrolling to content top
    var scrollContainerDivID = 'essentials-bundle-scroll-container';
    // filter the JSON-rendered products
    var _b = __read(useMemo(function () {
        var e_1, _a;
        var localBundleProduct;
        var localChoices = [];
        try {
            for (var products_1 = __values(products), products_1_1 = products_1.next(); !products_1_1.done; products_1_1 = products_1.next()) {
                var product = products_1_1.value;
                if (!localBundleProduct && product.tags.includes('Essentials Bundle - Main')) {
                    localBundleProduct = product;
                }
                else if (product.tags.includes('Essentials Bundle - Choice')) {
                    localChoices.push(product);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (products_1_1 && !products_1_1.done && (_a = products_1.return)) _a.call(products_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var localAvailableChoices = localChoices.reduce(function (arr, product) {
            return arr.concat(product.variants.map(function (variant) { return ({ product: product, variant: variant }); }));
        }, []);
        return [localBundleProduct, localAvailableChoices];
    }, []), 2), mainBundleProduct = _b[0], availableChoices = _b[1];
    var _c = __read((0, react_1.useState)(function () {
        if (existingBundle) {
            var children = existingBundle.children; // coddle typescript
            return children.reduce(function (arr, child) {
                var product = products.find(function (p) { return p.id === child.shopify_product_id; });
                var variant = product === null || product === void 0 ? void 0 : product.variants.find(function (v) { return v.id === child.shopify_variant_id; });
                return product && variant && (0, is_variant_available_1.default)(variant) ? arr.concat({ product: product, variant: variant, quantity: child.quantity }) : arr;
            }, []);
        }
        return [];
    }), 2), selectedChoices = _c[0], setSelectedChoices = _c[1];
    // create the queryClient used for graphQL
    var queryClient = (0, react_query_1.useQueryClient)();
    var subscriptionsApiClient = (0, api_1.getSubscriptionAPIClient)();
    // updateSubscription mutation
    var updateSubscription = (0, react_query_1.useMutation)(function (variables) { return subscriptionsApiClient.request(update_subscription_1.UPDATE_SUBSCRIPTION, variables); }, {
        onSuccess: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.invalidateQueries('getCustomerSubscriptions')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    }).mutateAsync;
    var _d = __read((0, react_1.useState)(''), 2), title = _d[0], setTitle = _d[1];
    var _e = __read((0, react_1.useState)(''), 2), subTitle = _e[0], setSubTitle = _e[1];
    var _f = __read((0, react_1.useState)(undefined), 2), leftSideImage = _f[0], setLeftSideImage = _f[1];
    var _g = __read((0, react_1.useState)(false), 2), isSubmittingBundle = _g[0], setIsSubmittingBundle = _g[1];
    var _h = __read((0, react_1.useState)(4), 2), frequency = _h[0], setFrequency = _h[1]; // default frequency to 4 weeks
    var totalNumChoices = useMemo(function () { return selectedChoices.reduce(function (sum, c) { return sum + c.quantity; }, 0); }, [selectedChoices]);
    // set up existing customer new bundle variables
    var _j = (0, existing_customer_new_bundle_1.useCreateNewBundle)('Fundamentals'), createNewBundleForExistingCustomer = _j.finalSubmit, createNewBundleForExistingCustomerError = _j.error, isCreatingNewBundleForExistingCustomer = _j.isCreatingNewBundleForExistingCustomer, didExistingCustomerCreateNewBundle = _j.didExistingCustomerCreateNewBundle, existingCustomerNewBundleParams = _j.queryParams, discountRecipe = _j.discountRecipe, getExistingCustomerNewBundleSavingsAndDiscount = _j.getSavingsAndDiscount;
    // update the promotionalCookie and the filteredPromotionalAddOns if the promoCode cookie or the mainVariant size has changed
    var promoCodeCookieValue = Cookies.get('promoCode');
    var filteredPromotionalAddOns = promotionalCodeProducts
        ? promotionalCodeProducts.filter(function (product) {
            var metaFields = promotionalCodeProductsMetafields ? promotionalCodeProductsMetafields["".concat(product.handle)] : undefined;
            // make sure promoCode metafield matches the promotionalCode in the cookie
            return metaFields && metaFields.promoCode === promoCodeCookieValue;
        })
        : [];
    // allocate promotional addOns based on variant options
    // if there is just one variant for the product, add it. else, choose the first of the multiple variants
    var promotionalAddOnVariants = (function () {
        return filteredPromotionalAddOns.reduce(function (arr, product) {
            var availableVariants = product.variants.filter(function (variant) { return (0, is_variant_available_1.default)(variant); });
            if (product.variants.length >= 1) {
                arr.push(__assign(__assign({}, availableVariants[0]), { product: { id: product.id } }));
            }
            return arr;
        }, []);
    })();
    // Set the header and scroll to top on location change
    (0, react_1.useEffect)(function () {
        if (location.pathname === '/') {
            setTitle(settings.selectProducts.title);
            setSubTitle(settings.selectProducts.subTitle);
        }
        else {
            setTitle(settings.review.title);
            setSubTitle(settings.review.subTitle);
        }
        var el = document.getElementById(scrollContainerDivID);
        if (el) {
            el.scrollTop = 0;
        }
    }, [location.pathname]);
    var _k = __read(useMemo(function () {
        var e_2, _a, e_3, _b;
        var price = 0;
        var subTotal = 0;
        try {
            // add up price for selected choices
            for (var selectedChoices_1 = __values(selectedChoices), selectedChoices_1_1 = selectedChoices_1.next(); !selectedChoices_1_1.done; selectedChoices_1_1 = selectedChoices_1.next()) {
                var _c = selectedChoices_1_1.value, variant = _c.variant, quantity = _c.quantity;
                price += variant.price * quantity;
                subTotal += variant.compare_at_price * quantity;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (selectedChoices_1_1 && !selectedChoices_1_1.done && (_a = selectedChoices_1.return)) _a.call(selectedChoices_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        try {
            // add up price for promotional add ons
            for (var promotionalAddOnVariants_1 = __values(promotionalAddOnVariants), promotionalAddOnVariants_1_1 = promotionalAddOnVariants_1.next(); !promotionalAddOnVariants_1_1.done; promotionalAddOnVariants_1_1 = promotionalAddOnVariants_1.next()) {
                var promoVariant = promotionalAddOnVariants_1_1.value;
                price += promoVariant.price;
                subTotal += promoVariant.compare_at_price;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (promotionalAddOnVariants_1_1 && !promotionalAddOnVariants_1_1.done && (_b = promotionalAddOnVariants_1.return)) _b.call(promotionalAddOnVariants_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var freeShippingQualified = price >= minPriceForFreeShipping;
        var _d = getExistingCustomerNewBundleSavingsAndDiscount(price), existingCustomerNewBundleSavings = _d.savings, existingCustomerNewBundleDiscount = _d.discount;
        return [subTotal, price, freeShippingQualified, existingCustomerNewBundleSavings, existingCustomerNewBundleDiscount];
    }, [selectedChoices, discountRecipe, promotionalAddOnVariants]), 5), subTotalBundlePrice = _k[0], totalBundlePrice = _k[1], qualifiesForFreeShipping = _k[2], existingCustomerNewBundleSavings = _k[3], existingCustomerNewBundleDiscount = _k[4];
    var addChoice = function (choice) {
        if (choice) {
            var existingIdx = selectedChoices.findIndex(function (c) { return c.variant.id === choice.variant.id; });
            var newChoices = selectedChoices.slice(0);
            if (existingIdx !== -1) {
                newChoices[existingIdx] = __assign(__assign({}, choice), { quantity: newChoices[existingIdx].quantity + 1 });
            }
            else {
                newChoices.push(__assign(__assign({}, choice), { quantity: 1 }));
            }
            setSelectedChoices(newChoices);
        }
    };
    var subChoice = function (choice) {
        if (choice) {
            var existingIdx = selectedChoices.findIndex(function (c) { return c.variant.id === choice.variant.id; });
            var newChoices = selectedChoices.slice(0);
            if (existingIdx !== -1) {
                if (newChoices[existingIdx].quantity === 1) {
                    newChoices.splice(existingIdx, 1);
                }
                else {
                    newChoices[existingIdx].quantity--;
                }
            }
            setSelectedChoices(newChoices);
        }
    };
    var addToCart = function (bundleItemParams) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, window.cartApp.add(bundleItemParams)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var submitBundle = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bundleId, shippingIntervalUnitType, sharedProps, childProps, parentProps, bundleItemParams, selectedChoices_2, selectedChoices_2_1, _a, variant, quantity, product, itemProperties, promotionalAddOnVariants_2, promotionalAddOnVariants_2_1, promoVariant, promoItemProperties, updatedSubscriptionId, params_1, shopifyVariantId, params, cdnBundleSettings;
        var e_4, _b, e_5, _c;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!mainBundleProduct)
                        return [2 /*return*/];
                    setIsSubmittingBundle(true);
                    bundleId = ((_d = existingBundle === null || existingBundle === void 0 ? void 0 : existingBundle.subscription.properties.find(function (_a) {
                        var name = _a.name;
                        return name === 'bundle_id';
                    })) === null || _d === void 0 ? void 0 : _d.value) || new Date().getTime().toString();
                    shippingIntervalUnitType = 'Weeks';
                    sharedProps = (function () {
                        var properties = {};
                        // We still add the original_bundle_value property for recharge bundles it's used by our cart app
                        properties.original_bundle_value = selectedChoices.reduce(function (sum, _a) {
                            var variant = _a.variant, quantity = _a.quantity;
                            return sum + Number(variant.compare_at_price || variant.price) * quantity;
                        }, 0) / 100;
                        if (!settings.app.rcBundlesForAcquisitionEnabled) {
                            properties.charge_interval_frequency = frequency;
                            properties.subscription_id = subscriptionId;
                            properties.shipping_interval_frequency = frequency;
                            properties.shipping_interval_unit_type = shippingIntervalUnitType;
                        }
                        return properties;
                    })();
                    childProps = __assign(__assign({}, sharedProps), { parent_bundle_id: bundleId });
                    parentProps = __assign(__assign({}, sharedProps), { bundle_id: bundleId });
                    bundleItemParams = [
                        { createItemParams: [mainBundleProduct.variants[0].id, { properties: parentProps }], variant: __assign(__assign({}, mainBundleProduct.variants[0]), { product: { id: mainBundleProduct.id } }) },
                    ];
                    try {
                        for (selectedChoices_2 = __values(selectedChoices), selectedChoices_2_1 = selectedChoices_2.next(); !selectedChoices_2_1.done; selectedChoices_2_1 = selectedChoices_2.next()) {
                            _a = selectedChoices_2_1.value, variant = _a.variant, quantity = _a.quantity, product = _a.product;
                            itemProperties = __assign(__assign({}, childProps), { compare_at_price: Number(variant.compare_at_price || variant.price) * 100 });
                            bundleItemParams.push({
                                createItemParams: [variant.id, { quantity: quantity, properties: itemProperties }],
                                variant: __assign(__assign({}, variant), { product: { id: product.id } }),
                            });
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (selectedChoices_2_1 && !selectedChoices_2_1.done && (_b = selectedChoices_2.return)) _b.call(selectedChoices_2);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    // only add promotional products to new bundles
                    if (!existingBundle) {
                        try {
                            for (promotionalAddOnVariants_2 = __values(promotionalAddOnVariants), promotionalAddOnVariants_2_1 = promotionalAddOnVariants_2.next(); !promotionalAddOnVariants_2_1.done; promotionalAddOnVariants_2_1 = promotionalAddOnVariants_2.next()) {
                                promoVariant = promotionalAddOnVariants_2_1.value;
                                promoItemProperties = { parent_bundle_id: bundleId, compare_at_price: Number(promoVariant.compare_at_price || promoVariant.price) * 100 };
                                bundleItemParams.push({
                                    createItemParams: [promoVariant.id, { quantity: 1, properties: promoItemProperties }],
                                    variant: __assign(__assign({}, promoVariant), { product: { id: promoVariant.product.id } }),
                                });
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (promotionalAddOnVariants_2_1 && !promotionalAddOnVariants_2_1.done && (_c = promotionalAddOnVariants_2.return)) _c.call(promotionalAddOnVariants_2);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                    }
                    // if there is a promoCode cookie present remove it since we're done with it now
                    Cookies.remove('promoCode');
                    if (!existingBundle) return [3 /*break*/, 2];
                    console.debug('existing bundle');
                    return [4 /*yield*/, updateSubscription({
                            itemUpdates: (0, utils_1.convertItemsToItemUpdateInputs)(bundleItemParams.map(function (item) { return item.createItemParams; })),
                            subscriptionId: existingBundle.subscription.id,
                        })];
                case 1:
                    updatedSubscriptionId = (_f.sent()).updateSubscription.subscription.id;
                    window.location.href = "".concat(subscriptionUrlLocation, "/").concat(updatedSubscriptionId);
                    return [3 /*break*/, 12];
                case 2:
                    if (!existingCustomerNewBundleParams) return [3 /*break*/, 7];
                    params_1 = bundleItemParams.map(function (item) { return item.createItemParams; });
                    shopifyVariantId = (function () {
                        if (settings.app.rcBundlesForAcquisitionEnabled) {
                            if (!mainRcBundleProduct)
                                throw new Error('Recharge bundles enabled but mainRcBundleProduct is missing');
                            return mainRcBundleProduct.variants[0].id; // we expect there to only be one variant, and it's the one we want
                        }
                        return params_1[0][0]; // main bundle product variant id
                    })();
                    _f.label = 3;
                case 3:
                    _f.trys.push([3, , 5, 6]);
                    return [4 /*yield*/, createNewBundleForExistingCustomer(__assign(__assign({}, existingCustomerNewBundleParams), { shopifyVariantId: shopifyVariantId, shippingIntervalUnitType: shippingIntervalUnitType, frequency: frequency, bundleId: bundleId, bundleItemParams: params_1 }))];
                case 4:
                    _f.sent();
                    return [3 /*break*/, 6];
                case 5:
                    setIsSubmittingBundle(false);
                    return [7 /*endfinally*/];
                case 6: return [3 /*break*/, 12];
                case 7:
                    console.debug('brand new customer');
                    (_e = window.dataLayer) === null || _e === void 0 ? void 0 : _e.push({ event: 'essentialsBundle__addToCart' });
                    params = void 0;
                    if (!settings.app.rcBundlesForAcquisitionEnabled) return [3 /*break*/, 9];
                    return [4 /*yield*/, (0, storefront_client_1.getCDNBundleSettings)(mainRcBundleProduct.id)];
                case 8:
                    cdnBundleSettings = _f.sent();
                    if (!cdnBundleSettings)
                        throw new Error("Failed to fetch bundle settings for product id ".concat(mainRcBundleProduct.id));
                    params = (0, recharge_bundles_1.buildDynamicRechargeBundle)({
                        choices: bundleItemParams,
                        cdnBundleSettings: cdnBundleSettings,
                        mainRcBundleProduct: mainRcBundleProduct,
                        shippingIntervalFrequency: frequency,
                        shippingIntervalUnitType: shippingIntervalUnitType,
                    });
                    return [3 /*break*/, 10];
                case 9:
                    params = bundleItemParams.map(function (item) { return item.createItemParams; });
                    _f.label = 10;
                case 10: return [4 /*yield*/, addToCart(params)];
                case 11:
                    _f.sent();
                    setIsSubmittingBundle(false);
                    _f.label = 12;
                case 12: return [2 /*return*/];
            }
        });
    }); };
    var canGoNext = useMemo(function () {
        switch (location.pathname) {
            case '/':
                return totalNumChoices >= minSelectionTotal;
            case '/review':
                return !!minSelectionTotal && totalNumChoices >= minSelectionTotal;
            default:
                return false;
        }
    }, [minSelectionTotal, totalNumChoices, location.pathname]);
    var pathBack = useMemo(function () {
        switch (location.pathname) {
            case '/review':
                return '/';
        }
    }, [location.pathname]);
    var pathNext = useMemo(function () {
        switch (location.pathname) {
            case '/':
                return '/review';
        }
    }, [location.pathname]);
    // prefetch this query for later use on the review screen
    var isLoggedIn = !!((_a = window.customer) === null || _a === void 0 ? void 0 : _a.id);
    (0, store_credit_1.useCustomerCreditAccount)({ enabled: !!isLoggedIn });
    // Initialize the recharge storefront sdk - we don't need a session so we don't wait for it
    var result = (0, recharge_storefront_1.useInitRechargeStorefrontSdk)();
    if (!result.initialized)
        return null;
    var contextValue = {
        availableChoices: availableChoices,
        selectedChoices: selectedChoices,
        minSelectionTotal: minSelectionTotal,
        minPriceForFreeShipping: minPriceForFreeShipping,
        existingBundle: existingBundle,
        existingCustomerNewBundleParams: existingCustomerNewBundleParams,
        addChoice: addChoice,
        subChoice: subChoice,
        canGoNext: canGoNext,
        frequency: frequency,
        pathBack: pathBack,
        pathNext: pathNext,
        promotionalCookie: promoCodeCookieValue,
        filteredPromotionalAddOns: filteredPromotionalAddOns,
        leftSideImage: leftSideImage,
        submitBundle: submitBundle,
        setLeftSideImage: setLeftSideImage,
        subTotalBundlePrice: subTotalBundlePrice,
        setFrequency: setFrequency,
        isSubmittingBundle: isSubmittingBundle,
        totalBundlePrice: totalBundlePrice,
        shippingIntervalUnitType: shippingIntervalUnitType,
        shippingIntervalFrequencies: shippingIntervalFrequencies,
        totalNumChoices: totalNumChoices,
        qualifiesForFreeShipping: qualifiesForFreeShipping,
        existingCustomerNewBundleSavings: existingCustomerNewBundleSavings,
        existingCustomerNewBundleDiscount: existingCustomerNewBundleDiscount,
    };
    return (react_1.default.createElement(exports.AppContext.Provider, { value: contextValue },
        react_1.default.createElement("div", { className: 'grid-x height-100 width-100' },
            react_1.default.createElement(loading_modal_1.default, { error: createNewBundleForExistingCustomerError, isLoading: isCreatingNewBundleForExistingCustomer }),
            react_1.default.createElement(existing_customer_new_bundle_modal_1.default, { isOpen: didExistingCustomerCreateNewBundle }),
            !existingBundle && (react_1.default.createElement("div", { className: 'cell show-for-large large-6 bg-pampas grid-y align-middle align-center' },
                react_1.default.createElement("img", { alt: 'essentials-leftside-image', src: leftSideImage, key: leftSideImage, className: 'margin-horizontal-auto', style: { maxHeight: '70vh' } }))),
            react_1.default.createElement("div", { className: 'cell auto grid-y height-100' },
                react_1.default.createElement("div", { className: 'cell auto overflow-y-auto bg-white', id: scrollContainerDivID },
                    react_1.default.createElement(header_1.default, { title: title, subtitle: subTitle }),
                    freeShippingAvailable && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: 'padding-horizontal-4 medium-padding-horizontal-6' },
                            react_1.default.createElement(progress_bar_1.default, { minPriceForFreeShipping: minPriceForFreeShipping, totalBundlePrice: totalBundlePrice })),
                        react_1.default.createElement(free_shipping_progress_1.default, { qualifiesForFreeShipping: qualifiesForFreeShipping, minPriceForFreeShipping: minPriceForFreeShipping, totalBundlePrice: totalBundlePrice, shippingAsterisk: settings.app.shippingAsterisk, shippingToolTipText: settings.app.shippingToolTipText, qualifiesForFreeShippingText: settings.app.qualifiesForFreeShippingText }))),
                    react_1.default.createElement(react_router_dom_1.Switch, null,
                        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: '/', component: select_products_1.default }),
                        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: '/review', component: review_1.default }))),
                react_1.default.createElement(nav_bar_1.default, null)))));
};
exports.default = (0, react_router_dom_1.withRouter)(App);
